module.exports = __webpack_public_path__ + "img/uk.4e53a9f9.svg";